<!-- start sidebar visual -->
<div class="sidebar bg-white dark:bg-black">
  @for (sidebarItem of sidebarItems; track sidebarItem) {
    @if (sidebarItem.type === 'url') {
      <a
        [routerLink]="sidebarItem.fullUrl"
        class="sidebar-item hover:bg-gray-100 dark:hover:bg-gray-850 flex flex-col items-center justify-center px-3 py-2 rounded-lg text-center"
        >
        <!-- Icon + Badge -->
        <div class="relative">
          <app-icon
            class="sidebar-item-icon"
            fontSize="30px"
            height="h-7"
            width="w-7"
            [icon]="sidebarItem.icon">
          </app-icon>
          <!-- Badge (only if badgeCount exists and > 0) -->
          @if (sidebarItem.badgeCount && sidebarItem.badgeCount > 0) {
            <app-number-badge [count]="sidebarItem.badgeCount"></app-number-badge>
          }
        </div>
        <!-- Label -->
        <span class="text-xs mt-1">
          {{ sidebarItem.localeKey | localizeText : sidebarItem.translationDefault }}
        </span>
      </a>
    } @else {
      <span class="block h-4"></span>
    }
  }
</div>
<!-- end sidebar visual -->
